/* eslint-disable no-empty */
/*eslint-disable @typescript-eslint/no-empty-function */
import { delayedScheduler } from './scheduler';

export const trackCityTemplateEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const CITY_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic bus:city';
    const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
    try {
      // @ts-ignore
      const { s, cityName } = window;
      s.pageName = CITY_TEMPLATE_OMNITURE_PAGE_NAME;
      if (fromCity !== '' && toCity !== '') s.prop3 = `${fromCity}-${toCity}`; //set prop3 when on going to listing page
      s.eVar15 = CITY_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.prop54 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,eVar15,eVar24,prop54,prop3';
      // @ts-ignore
      s.tl(this, CITY_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackRouteTemplateQueuedEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const ROUTE_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic bus:route';
    const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
    try {
      // @ts-ignore
      const { s } = window;
      const sourceCityData =
        window['__INITIAL_STATE__']['sourceCityData']['name'];
      const destinationCityData =
        window['__INITIAL_STATE__']['destinationCityData']['name'];
      s.pageName = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar3 =
        fromCity === ''
          ? `${sourceCityData}-${destinationCityData}`
          : `${fromCity}-${toCity}`;
      s.eVar15 = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.eVar22 = ERROR_CODE;
      s.prop54 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,prop2,eVar15,eVar22,eVar24,prop54,prop3';
      // @ts-ignore
      s.tl(this, ROUTE_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackRouteTemplateEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  const ROUTE_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic bus:route';
  const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
  try {
    // @ts-ignore
    const { s } = window;
    const sourceCityData =
      window['__INITIAL_STATE__']['sourceCityData']['name'];
    const destinationCityData =
      window['__INITIAL_STATE__']['destinationCityData']['name'];
    s.pageName = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
    s.eVar3 =
      fromCity === ''
        ? `${sourceCityData}-${destinationCityData}`
        : `${fromCity}-${toCity}`;
    s.eVar15 = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
    s.eVar24 = `domestic bus`;
    s.eVar22 = ERROR_CODE;
    s.prop54 = eventWithValToTrack;
    s.linkTrackVars = 'channel,eVar3,prop2,eVar15,eVar22,eVar24,prop54,prop3';
    // @ts-ignore
    s.tl(this, ROUTE_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
  } catch (e) {}
};

export const trackNewRouteEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const ROUTE_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic bus:route';
    try {
      // @ts-ignore
      const { s } = window;
      const sourceCityData =
        window['__INITIAL_STATE__']['sourceCityData']['name'];
      const destinationCityData =
        window['__INITIAL_STATE__']['destinationCityData']['name'];
      s.pageName = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar3 =
        fromCity === ''
          ? `${sourceCityData}-${destinationCityData}`
          : `${fromCity}-${toCity}`;
      s.eVar15 = ROUTE_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.eVar58 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,prop2,eVar15,eVar24,eVar58,prop3';
      // @ts-ignore
      s.tl(this, ROUTE_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};

export const trackOperatorTemplateEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME = 'seo:domestic bus:operator';
    const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
    try {
      // @ts-ignore
      const { s } = window;
      const operatorName = window['__INITIAL_STATE__']['operatorName'];
      s.pageName = OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      if (fromCity !== '') s.eVar3 = `${fromCity}-${toCity}`;
      s.eVar15 = OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.eVar22 = ERROR_CODE;
      s.prop54 = eventWithValToTrack;
      if (fromCity != '' && toCity != '') s.prop3 = `${fromCity}-${toCity}`; //set prop3 when on going to listing page
      s.linkTrackVars = `channel${
        fromCity === '' ? ',' : `,eVar3,`
      }prop2,eVar15,eVar22,eVar24,prop54,prop3`;
      // @ts-ignore
      s.tl(this, OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME, eventWithValToTrack);
    } catch (e) {}
  });
};
export const trackRouteCategoryTemplateEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const ROUTE_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic bus:route category';
    const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
    try {
      // @ts-ignore
      const { s } = window;
      const sourceCityName =
        window['__INITIAL_STATE__']['routeData']['sourceCityData']['name'];
      const destinationCityName =
        window['__INITIAL_STATE__']['routeData']['destinationCityData']['name'];
      const categoryName =
        window['__INITIAL_STATE__']['categoryData']['friendlyCategoryName'];
      s.pageName = ROUTE_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME;
      if (fromCity) {
        s.eVar3 = `${fromCity}-${toCity}`;
      }
      s.eVar15 = ROUTE_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.eVar22 = ERROR_CODE;
      s.prop54 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,prop2,eVar15,eVar22,eVar24,prop54,prop3';
      // @ts-ignore
      s.tl(
        this,
        ROUTE_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack,
      );
    } catch (e) {}
  });
};
export const trackRouteOperatorTemplateEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic bus:route operator';
    const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
    try {
      // @ts-ignore
      const { s } = window;
      const sourceCityName =
        window['__INITIAL_STATE__']['routeData']['sourceCityData']['name'];
      const destinationCityName =
        window['__INITIAL_STATE__']['routeData']['destinationCityData']['name'];
      const operatorName =
        window['__INITIAL_STATE__']['operatorData']['operatorName'];
      s.pageName = ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      if (fromCity) {
        s.eVar3 = `${fromCity}-${toCity}`;
      }
      s.eVar15 = ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.eVar22 = ERROR_CODE;
      s.prop54 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,prop2,eVar15,eVar22,eVar24,prop54,prop3';
      // @ts-ignore
      s.tl(
        this,
        ROUTE_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack,
      );
    } catch (e) {}
  });
};
export const trackCityOperatorTemplateEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic bus:city operator';
    const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
    try {
      // @ts-ignore
      const { s } = window;
      const cityName = window['__INITIAL_STATE__']['cityData']['name'];
      const operatorName =
        window['__INITIAL_STATE__']['operatorData']['operatorName'];
      s.pageName = CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      if (fromCity) {
        s.eVar3 = `${fromCity}-${toCity}`;
      }
      s.eVar15 = CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.eVar22 = ERROR_CODE;
      s.prop54 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,prop2,eVar15,eVar22,eVar24,prop54,prop3';
      // @ts-ignore
      s.tl(
        this,
        CITY_OPERATOR_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack,
      );
    } catch (e) {}
  });
};
export const trackCityCategoryTemplateEvent = (
  eventWithValToTrack: string,
  fromCity = '',
  toCity = '',
) => {
  delayedScheduler(() => {
    const CITY_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME =
      'seo:domestic bus:city category';
    const ERROR_CODE = `BUS_ERROR_LISTING_NO_RESULTS`;
    try {
      // @ts-ignore
      const { s } = window;
      const cityName = window['__INITIAL_STATE__']['cityData']['name'];
      const categoryName =
        window['__INITIAL_STATE__']['categoryData']['categoryName'];
      s.pageName = CITY_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME;
      if (fromCity) {
        s.eVar3 = `${fromCity}-${toCity}`;
      }
      s.eVar15 = CITY_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME;
      s.eVar24 = `domestic bus`;
      s.eVar22 = ERROR_CODE;
      s.prop54 = eventWithValToTrack;
      s.linkTrackVars = 'channel,eVar3,prop2,eVar15,eVar22,eVar24,prop54,prop3';
      // @ts-ignore
      s.tl(
        this,
        CITY_CATEGORY_TEMPLATE_OMNITURE_PAGE_NAME,
        eventWithValToTrack,
      );
    } catch (e) {}
  });
};
export const trackAdView = (eventWithValToTrack: string) => {
  const templateName =
    window['__INITIAL_STATE__']['templateData']['templateName'];
  if (templateName === 'city')
    trackCityTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_Template'),
    );
  else if (templateName === 'route')
    trackRouteTemplateEvent(
      eventWithValToTrack.replace('Template', 'Route_Template'),
    );
  else if (templateName === 'operator')
    trackOperatorTemplateEvent(
      eventWithValToTrack.replace('Template', 'Operator_Template'),
    );
  else if (templateName === 'route_category')
    trackRouteCategoryTemplateEvent(
      eventWithValToTrack.replace('Template', 'Route_Category_Template'),
    );
  else if (templateName === 'route_operator')
    trackRouteOperatorTemplateEvent(
      eventWithValToTrack.replace('Template', 'Route_Operator_Template'),
    );
  else if (templateName === 'city_operator')
    trackCityOperatorTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_Operator_Template'),
    );
  else if (templateName === 'city_category')
    trackCityCategoryTemplateEvent(
      eventWithValToTrack.replace('Template', 'City_Category_Template'),
    );
};
